import BConfig from "../BConfig";
import BForm from "../BForm";
import BRequest from "../BRequest";
import BScroll from "../BScroll";

export default class BCaloricCalculator
{
	constructor(el) {
		this.el = el;
	}

	getForm()
	{
		return new BForm(this.el);
	}

	getResult()
	{
		this.getForm().resetErrors();

		this.sendRequest(this.getForm().getData()).then(response => {
			this.setResponse(response);
		}).catch(error => {
			try {
				this.scrollToTop();
			} catch (error) {
				// Nevermind.
			}

			this.getForm().setErrorResponse(error);
		});
	}

	sendRequest(data)
	{
		return BRequest.get(BConfig.getRoute("api.v2.caloricCalculator.getMetrics"), data);
	}

	scrollToTop()
	{
		BScroll.top(this.el);
	}

	setOutputMetric(metric)
	{
		try {
			const selector = `.caloric-calculator__output [data-metric="${metric.name}"] .result`;
			this.el.querySelectorAll(selector).forEach(el => {
				el.innerHTML = metric.formatted;
			});
		} catch (error) {
			console.debug(error);
		}

		try {
			const selector = `.caloric-calculator__output .caloric-meter[data-metric="${metric.name}"] .pointer`;
			this.el.querySelectorAll(selector).forEach(el => {
				el.setAttribute(`style`, `transform: rotate(${90 + (112.5 * metric.result)}deg)`);
			});
		} catch (error) {
			console.debug(error);
		}
	}

	showInput()
	{
		this.el.querySelector(`.caloric-calculator__input`).removeAttribute('hidden');
	}

	hideInput()
	{
		this.el.querySelector(`.caloric-calculator__input`).setAttribute('hidden', '');
	}

	showOutput()
	{
		this.el.querySelector(`.caloric-calculator__output`).removeAttribute('hidden');

		try {
			window.nutriangle();
		} catch (error) {
			// Yeah...
		}
	}

	hideOutput()
	{
		this.el.querySelector(`.caloric-calculator__output`).setAttribute('hidden', '');
	}

	// $.fn.caloricCalculatorClearOutputMessages = function() {
	// 	$(this).find('.caloric-calculator__output .messages').html('');
	// }

	// $.fn.caloricCalculatorAddOutputMessage = function(message) {
	// 	$(this).find('.caloric-calculator__output .messages').append('<p>' + message + '</p>')
	// }

	// $(document).on('click', '#sportDurationNoneRadio', function(event) {
	// 	$('#sportDurationLowFrequencyRadio, #sportDurationAerobicRadio, #sportDurationAnaerobicRadio').on('click', function(event) {
	// 		console.log("A");
	// 	});
	// });

	// // Options item - active class.
	// $('.caloric-calculator .options input[type="radio"], .caloric-calculator .options input[type="checkbox"]').on('change init', function() {
	// 	$('.caloric-calculator .options input[type="radio"], .caloric-calculator .options input[type="checkbox"]').each(function(index, el) {
	// 		if ($(this).is(':checked')) {
	// 			$(this).closest('.item').addClass('active');
	// 		} else {
	// 			$(this).closest('.item').removeClass('active');
	// 		}
	// 	});
	// }).trigger('init');

	// // Tabs - active class.
	// $('input','.caloric-calculator .tab-nav').on('change init',function() {
	// 	if ($(this).is(':checked')) {
	// 		$('input', '.caloric-calculator .tab-nav').closest('label').removeClass('active');
	// 		$(this).closest('label').addClass('active');
	// 	}
	// 	else {
	// 		$(this).closest('label').removeClass('active');
	// 	}
	// }).trigger('init');

	// // My goals - sync weight inputs.
	// $('.options.goals input[type="text"]').on('keyup init',function() {
	// 	let val = $(this).val();
	// 	$('.options.goals input[type="text"]').val(val);
	// });

	// // Carbs - sync weight inputs.
	// $('[name="dietCarbs"]').on('keyup init',function() {
	// 	let val = $(this).val();
	// 	$('[name="dietCarbs"]').val(val);
	// });

	// $(document).on('click', '.push-notification-button', function(event) {
	// 	event.preventDefault();
	// 	let form = $(this).closest('form');
	// 	window.OneSignal = window.OneSignal || [];
	// 	window.OneSignal.push(function() {
	// 		window.OneSignal.showSlidedownPrompt();
	// 		window.OneSignal.sendTags({
	// 			segment: "caloricCalculator",
	// 			reference: form.attr('data-reference'),
	// 		});
	// 	});
	// });
}
